export const config = {
  activeLine: {
    active: false,
    respond: false,
    style: {
      stroke: "#000000",
      strokeWidth: 3,
      opacityMapping: "MGroup19",
    },
    backgroundStyle: undefined,
  },
  axes: {
    y: {
      show: true,
      tickSizeInner: 5,
      tickLineColour: "grey",
      domainColour: "grey",
      textColour: "grey",
    },
    x: {
      show: true,
      tickSizeInner: 5,
      tickLineColour: "grey",
      domainColour: "grey",
      textColour: "grey",
    },
  },
  layout: {
    margin: {
      top: 40,
      right: 20,
      bottom: 30,
      left: 50,
    },
  },
  brush: {
    x: { width: 15, active: false, margin: 0 },
    y: { width: 15, active: false, margin: 10 },
  },
  valueFilter: undefined, //(d)=>parseDate(item.Date)
  svg: { Background: "#ffffff", border: "none" },
  border: { stroke: "#f6f6f6", strokeWidth: 1 },
  colourMapping: {
    Close: {
      stroke: "#F28E2B",
      strokeWidth: 2,
    },
    TopBottom: {
      stroke: "#68CEEE",
      strokeWidth: 2,
    },
    Vector_95Frcst: {
      stroke: "#68CEEE",
      strokeWidth: 2,
    },
    Vector_99Frcst: {
      stroke: "#96F2EE",
      strokeWidth: 2,
    },
    Vector_BodyFrcst: {
      stroke: "#051C61",
      strokeWidth: 2,
    },
    Sigma_95Frcst: {
      stroke: "#FF9DA7",
      strokeWidth: 2,
    },
    Sigma_99Frcst: {
      stroke: "#E15759",
      strokeWidth: 2,
    },
    "vs1 thru vs20": {
      stroke: "#49525E",
      strokeWidth: 2,
    },
    "vs21 thru vs60": {
      stroke: "#A4A9AB",
      strokeWidth: 2,
    },
    "vs61 thru vs325": {
      stroke: "#D5D5D5",
      strokeWidth: 2,
    },
  },
  header: {
    text: "",
    colour: "#CBA266",
    fontSize: 14,
    fontWeight: 600,
    margin: { left: 10, top: 20 },
  },
  ignoreVectorsInVectorSetFilter: false,
  ignoreVecLevelFilter: false,
  ignoreVecEventsFilter: false,
  ignoreVecDatesFilter: false,
  opacityMapping: {
    MGroup19: {
      Fade: 0,
    },
    MGroup18: {
      Fade: 80,
    },
    MGroup17: {
      Fade: 80,
    },
    MGroup16: {
      Fade: 80,
    },
    MGroup15: {
      Fade: 80,
    },
    MGroup14: {
      Fade: 80,
    },
    MGroup13: {
      Fade: 80,
    },
    MGroup12: {
      Fade: 80,
    },
    MGroup11: {
      Fade: 80,
    },
    MGroup10: {
      Fade: 80,
    },
    MGroup9: {
      Fade: 80,
    },
    MGroup8: {
      Fade: 80,
    },
    MGroup7: {
      Fade: 80,
    },
    MGroup6: {
      Fade: 80,
    },
    MGroup5: {
      Fade: 80,
    },
    MGroup4: {
      Fade: 80,
    },
    MGroup3: {
      Fade: 80,
    },
    MGroup2: {
      Fade: 80,
    },
    MGroup1: {
      Fade: 80,
    },
  },
  tooltips: {
    active: true,
    offset: 6,
    text: { fontSize: 14, fontWeight: 600, color: "#ffffff" },
    lineHeight: 3,
    box: {
      fill: "#182235",
      stroke: "#182235",
      strokeWidth: 1,
      radius: 4,
    },
    triangle: {
      size: 64,
      height: 12,
      marginTop: 3,
      mousetopointergap: 4,
    },
    table: { label: { width: 50 } },
  },
  horizontalLines: undefined,
  verticalLines: undefined, //{date:parsedate("1/3/2023"),label:{textAnchor:"left"/"right",colour:"pink",fontSize: 12,fontWeight: 600,}}]
};
